<template lang="pug">
div.tw-flex.tw-flex-col.tw-mt-3(class="tw-text-[14px] emd:tw-gap-1" v-if="!stepper.inSearchPage" )
	brief-go-back-button(:btn-text="searchBriefButton" :formatted-price="formattedPrice" :is-mobile="isMobile" v-if="isMobile")
	brief-dep-arr(:is-round-trip="bookingStore.isRoundTrip" :departure-station="departureStation" :arrival-station="arrivalStation" v-if="!stepper.inPassengersDataPage")

	div.tw-flex.tw-items-start.tw-gap-8.tw-items-center
		div(
			@click="showDetails"
			:class="(stepper.inPassengersDataPage ? 'tw-cursor-pointer' : '')"
			class="emd:tw-w-full"
			)
			brief-dep-arr(:is-round-trip="bookingStore.isRoundTrip" :departure-station="departureStation" :arrival-station="arrivalStation" v-if="stepper.inPassengersDataPage")

			div.tw-flex.tw-items-center.tw-gap-2(class="emd:tw-w-full emd:tw-justify-between")
				div(:class="(searchFilters.children > 0 || stepper.inPassengersDataPage) ? '' : 'emd:tw-flex emd:tw-flex-row emd:tw-grow emd:tw-gap-2'")
					div.tw-flex(v-if='startDateStr')
						div(v-if='bookingStore.isRoundTrip' class="tw-w-[35px]") {{ $t('form_labels.departure2', 'Part.') }}:
						div {{ startDateStr }}
					div.tw-flex(v-if='bookingStore.isRoundTrip && returnDate')
						div(class="tw-w-[35px]") {{ $t('form_labels.return2', 'Rit.') }}:
						div {{ returnDate }} {{returnTime}}

				template(v-if='stepper.bookingType != "carnet"')
					v-icon(icon="mdi-circle-small" small v-if="!isMobile" )
					div.tw-flex.tw-flex-col
						span(v-if="searchFilters.adult > 0") {{ searchFilters.adult }} {{ searchFilters.adult > 1 ? $t("common.adult", 0) : $t("common.adult", 1) }}
						//span(v-if="searchFilters.children > 0 && searchFilters.adult > 0") +
						//span {{ searchFilters.adult }} {{ searchFilters.children > 1 ? $t("common.children", 0) : $t("common.children", 1) }}
						span(v-if="searchFilters.children > 0") {{ searchFilters.children }} {{ searchFilters.children > 1 ? $t("common.children", 0) : $t("common.children", 1) }}
		v-icon(
			v-if="stepper.inPassengersDataPage"
			@click="showDetails"
			color="primary-darken-1"
			icon="mdi-information-outline"
			class="tw-w-[35px]"
			:size="isMobile ? 35 : 'default'"
		)
		brief-go-back-button(:btn-text="searchBriefButton" :formatted-price="formattedPrice" :is-mobile="isMobile" v-if="!isMobile")

div.tw-justify-end(class="emd:tw-w-full")
	div.tw-flex-1(id="app-header-info-area")
</template>

<script setup>
import { printCurrencyValue } from '@/common-scripts/utilities';
import { useBookingStore } from '@/stores/booking';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import {computed, inject, ref, shallowRef, watch} from 'vue';
import {get as _get} from "lodash-es";
import {useDialogManagerStore} from "@/stores/dialog-manager";
import SummaryTravelsolutionChosen from "@/common-components/dialogs/summary-travelsolution-chosen.vue";
import BriefGoBackButton from "@/sale/components/header-bar/brief-goBackButton.vue";
import BriefDepArr from "@/sale/components/header-bar/brief-dep-arr.vue";
import {useI18n} from "vue-i18n";


const i18n = useI18n();
const props = defineProps({
	returnDate: {
		type: String,
		default: null
	},
	returnTime: {
		type: String,
		default: null
	}
});
const isMobile = inject('isMobile');
const bookingStore = useBookingStore();
const stepper = useBookingStepperStore();
const searchContext = ref((!stepper.inPassengersDataPage || 'carnet-solutions' == stepper.step));
const travelSolution = shallowRef(_get(bookingStore.forwardTravel.evaluatedSolution, 'viewTravelSolutions.0'));
const searchFilters = bookingStore.searchFilters;
const returnDate = computed(() => {
	if(!bookingStore.searchFilters.returnDate) return;
	return bookingStore.searchFilters.returnDate.toLocaleDateString();
});
const returnTime = computed(() => {
	if(!bookingStore.searchFilters.returnDate) return;
	return bookingStore.searchFilters.returnDate.toLocaleTimeString(undefined, {hour:'2-digit', minute:'2-digit', hour12: false});
});
const startDateStr = computed(() => {
	if(searchContext.value && !searchFilters.startDate) return;
	if(travelSolution.value && !travelSolution.value.departure) return;
	const d = searchContext.value ? searchFilters.startDate : new Date(travelSolution.value.departure);
	return d.toLocaleDateString() + ' ' + d.toLocaleTimeString(undefined, {hour:'2-digit', minute:'2-digit', hour12: false});
});
const formattedPrice = computed(() => {
	if(!bookingStore.selectedTotalPrice) return;
	return printCurrencyValue(bookingStore.selectedTotalPrice);
});
const departureStation = computed(() => {
	return searchContext.value ? searchFilters.departureStation.name : travelSolution.value.start.stationName;
});
const arrivalStation = computed(() => {
	return searchContext.value ? searchFilters.arrivalStation.name : travelSolution.value.end.stationName;
});
const searchBriefButton = computed(() => {
	if ('forward-travel-solutions' == stepper.step) return i18n.t('common.edit');
	return i18n.t('common.back');
});


async function showDetails() {
	if(!stepper.inPassengersDataPage) return;
	let ts = [travelSolution.value];
	if (bookingStore.returnTravel.evaluatedSolution && _get(bookingStore.returnTravel.evaluatedSolution, 'viewTravelSolutions.0')) {
		ts.push(_get(bookingStore.returnTravel.evaluatedSolution, 'viewTravelSolutions.0'));
	}
	await useDialogManagerStore()
		.openSimpleMessageDialog({
			travelSolutions: ts,
			passengers: bookingStore.passengers,
			searchCriteria: bookingStore.searchFilters,
			isRoundTrip: bookingStore.isRoundTrip,
			servicesMap: bookingStore.servicesMap,
			passengersSelectionMap: bookingStore.passengersSelectionMap,
		}, true, SummaryTravelsolutionChosen)
		.catch(e => {
			console.error('error - showTravelSolutionSelectedDetails', e);
		});
}


watch(() => bookingStore.forwardTravel.evaluatedSolution, (value, old) => {
	if (!_get(bookingStore.forwardTravel.evaluatedSolution, 'viewTravelSolutions.0')) return;
	travelSolution.value = _get(bookingStore.forwardTravel.evaluatedSolution, 'viewTravelSolutions.0');
});
</script>

<style scoped>
.v-input__control .v-field.v-theme--forexchange {
	border: 0 !important;
	border-bottom: 2px solid #dfdfdf;
}
</style>